module.exports = __webpack_public_path__ + "static/media/IMG_1129.790f7876.jpg";